/**
 * clipboard.adapter — ห่อ `navigator.clipboard` ให้ feature ใช้ได้โดยไม่แตะ global เอง
 *
 * 🔑 **ทำไมอยู่ใน `shared/` ไม่ใช่ `member/`** — "คัดลอกข้อความ" ไม่ผูกกับธุรกิจฝั่งไหนเลย
 *    `activities-admin--web` (Day 7) ใช้ตัวเดียวกันได้ทันที
 *
 * ⚠️ **type ประกาศที่นี่เอง ไม่ import `ClipboardPort` ของ feature** — feature เป็นคน
 *    ประกาศสัญญาที่ *ตัวเองต้องการ* (`types/clipboard.port.ts`) ส่วนตัวนี้ประกาศสิ่งที่
 *    *ตัวเองให้ได้* · ทั้งคู่ตรงกันแบบ structural ⇒ ประกอบเข้าหากันได้โดยไม่มีใครพึ่งใคร
 *    (นี่คือหลัก *"ของที่ทุกคนต้องรู้จัก ต้องเป็นของที่ไม่รู้จักใครเลย"* — และกฎ
 *     `no-cross-scope-within-layer` บังคับข้อนี้ให้แล้ว: `shared/` import `member/` ไม่ได้)
 */
export type ClipboardWriter = {
  /** reject ได้ — ผู้ใช้ไม่อนุญาต หรือเบราว์เซอร์ไม่รองรับ ⇒ UI ต้องบอกทางเลือกอื่น */
  writeText(text: string): Promise<void>;
};

export function createClipboardAdapter(): ClipboardWriter {
  return {
    async writeText(text) {
      /**
       * ⚠️ `navigator.clipboard` **ไม่มีเมื่อไม่ใช่ secure context** (http ที่ไม่ใช่
       *    localhost) และผู้ใช้ปฏิเสธสิทธิ์ได้ ⇒ ต้อง reject ให้ชัด **ห้ามเงียบ**
       *    หน้าเว็บมีสถานะรองรับอยู่แล้ว (บอกให้กดค้างที่ลิงก์คัดลอกเอง)
       */
      if (navigator.clipboard === undefined) {
        throw new Error('เบราว์เซอร์นี้คัดลอกอัตโนมัติไม่ได้');
      }

      await navigator.clipboard.writeText(text);
    },
  };
}
